import { render, staticRenderFns } from "./ImageDetailsStepTwo.vue?vue&type=template&id=6bba07aa&scoped=true&"
import script from "./ImageDetailsStepTwo.vue?vue&type=script&lang=js&"
export * from "./ImageDetailsStepTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bba07aa",
  null
  
)

export default component.exports